import React from 'react';
export const ComponentContext = React.createContext<
	Record<string, (props: any) => JSX.Element>
>({});
